module.exports = __webpack_public_path__ + "static/fc530b55-d330-4be3-be64-2264205dea66-c8af527594cc42a4a7c33f20c05e1989.webp";